import { Link } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-200">404</h1>
        <h2 className="text-2xl font-bold text-gray-900 mt-4">صفحه مورد نظر یافت نشد</h2>
        <p className="text-gray-500 mt-2">صفحه‌ای که به دنبال آن هستید وجود ندارد یا حذف شده است</p>
        <Link to="/" className="inline-flex items-center gap-2 mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">
          <Home className="w-5 h-5" />
          بازگشت به صفحه اصلی
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};